import { useEffect, useState } from "react";
import { GET_ALL_CONTRACTS, GET_ALL_PAYMENTS } from "../../api/apiContratos";
import Breadcrumb from "../molecules/Breadcrumb";
import { PropagateLoader } from "react-spinners";
import GlobalContractStats from "../organisms/ContratosAdmin/GlobalContractStats";

const ContratosTemplate = () => {
	const [contracts, setContracts] = useState([]);
	const [payments, setPayments] = useState([]);
	const [loading, setLoading] = useState(true);

	const fetchContracts = async () => {
		try {
			const data = await GET_ALL_CONTRACTS();
			setContracts(data || []);
		} catch (error) {
			console.error("Error fetching contracts:", error);
			setContracts([]);
		}
	};

	const fetchPayments = async () => {
		try {
			const data = await GET_ALL_PAYMENTS();
			setPayments(data || []);
		} catch (error) {
			console.error("Error fetching payments:", error);
			setPayments([]);
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		const fetch = async () => {
			await Promise.all([fetchContracts(), fetchPayments()]);
		};
		fetch();
	}, []);

	return (
		<div className="space-y-6">
			<Breadcrumb
				items={[
					{ label: "Inicio", to: "/dashboard" },
					{ label: "Contratos", to: null },
				]}
			/>
			{loading ? (
				<div className="w-full h-40 flex justify-center items-center">
					<PropagateLoader color="red" />
				</div>
			) : (
				<>
					<GlobalContractStats contracts={contracts} payments={payments} />
				</>
			)}
		</div>
	);
};

export default ContratosTemplate;